/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Payments_Cancelled_ToastInputs */

const en_my_payments_cancelled_toast = /** @type {(inputs: My_Payments_Cancelled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your subscription ends at the end of the paid period.`)
};

const pl_my_payments_cancelled_toast = /** @type {(inputs: My_Payments_Cancelled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subskrypcja zakończy się z końcem opłaconego okresu.`)
};

/**
* | output |
* | --- |
* | "Your subscription ends at the end of the paid period." |
*
* @param {My_Payments_Cancelled_ToastInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const my_payments_cancelled_toast = /** @type {((inputs?: My_Payments_Cancelled_ToastInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Payments_Cancelled_ToastInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_my_payments_cancelled_toast(inputs)
	return en_my_payments_cancelled_toast(inputs)
});